import ThemeContext from "components/app/Context";
import { markPlanCompleteAsync } from "components/features/MyPlanDetails/MyPlanDetails.slice";
import { useTranslate } from "hooks/useTranslate";
import React, { useContext, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { accessTypes, completed } from "utils/CommonConstants";
import { getUserHltId } from "utils/CommonFunctions";
import Button from "./Button";
import DialogFormation from "./DialogFormation";
import { setFeedbackDetails } from "./Snackbar/snackbar.slice";
import Typography from "./Typography";

interface source {
  source: string;
  sectionId?: number;
}

interface Props {
  source?: source;
  sx?: object;
  width?: string;
  disabled?: boolean;
  variant?: "primary" | "primaryWhite" | "secondary" | "secondaryWhite" | "alert" | "contained" | "outlined" | "text";
}

function MarkCompleteButton(props: Props) {
  const translate = useTranslate();
  const { isMobileScreen }: any = useContext(ThemeContext);
  const { source, sx, variant = "primary", width = isMobileScreen ? "100%" : "none", disabled = false } = props;
  const dispatch = useAppDispatch();
  const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
  const isActionHighlight = useAppSelector((state: any) => state.myplans?.MyPlans.isActionHighlight);
  const [sectionPayload, setSectionPayload] = React.useState<any>([]);
  const [cardsToComplete, setCardsToComplete] = React.useState<any>({ notAssignedToMe: [], assignedToMe: [] });
  const { cardList, sectionId } = useAppSelector((state) => state.app.selectedCards);
  const selectedMyPlanDetail = useAppSelector((state) => state.myPlanDetails.myPlanDetails);

  const formDataAndSectionPayload = () => {
    let notAssigned: string[] = [];
    let assigned: string[] = [];
    let sectionPayload: any[] = [];
    let cards: any[] = [];
    let myplanDetails =
      source?.source === "section"
        ? selectedMyPlanDetail?.sections?.filter((item: any) => item?.id === source?.sectionId)
        : selectedMyPlanDetail?.sections;
    if (cardList.length && source?.sectionId === sectionId) myplanDetails[0] = { ...myplanDetails[0], cards: cardList };
    myplanDetails?.map((item: any) => {
      cards = [];
      item?.cards
        ?.filter((fil: any) => fil?.status !== completed)
        ?.map((item2: any) => {
          if (item2?.assignee?.some((assigneeId: any) => getUserHltId() === assigneeId)) {
            cards.push(item2?.id);
            assigned.push(item2?.id);
          } else {
            if (!isActionHighlight) cards.push(item2?.id);
            notAssigned.push(item2?.id);
          }
        });
      if (cards?.length) sectionPayload.push({ id: item?.id, cards });
    });

    setSectionPayload(sectionPayload);
    const actionObj = { notAssignedToMe: notAssigned, assignedToMe: assigned };
    setCardsToComplete(actionObj);
    return actionObj;
  };

  const handleOnClick = async () => {
    const cardsToComplete = await formDataAndSectionPayload();
    if (
      (!cardsToComplete?.assignedToMe?.length && !cardsToComplete?.notAssignedToMe?.length) ||
      (isActionHighlight && !cardsToComplete?.assignedToMe?.length)
    )
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          variant: "error",
          setState: setFeedbackDetails({ shouldShow: false }),
          message: translate("myplan.actionCompleted.feedback")
        })
      );
    else setShowConfirmationDialog(true);
  };

  const getMarkAsCompleteActionType = () => {
    if (cardList.length && source?.sectionId === sectionId) return "section_multiselect";
    else if (isActionHighlight && source?.source === "section") return "section_highlighted";
    else return source?.source;
  };

  const handleProceed = () => {
    dispatch(
      markPlanCompleteAsync({
        planId: selectedMyPlanDetail?.id,
        type: getMarkAsCompleteActionType(),
        isActionHighlight,
        payload: {
          updateType: "COMPLETE_CARD",
          sections: sectionPayload
        }
      })
    );
  };

  const handleClose = () => {
    setShowConfirmationDialog(false);
  };

  return (
    <>
      <Button
        disabled={disabled}
        sx={{ ...sx }}
        width={width}
        onClick={handleOnClick}
        variant={variant}
        label="Mark As Completed"
        accessType={accessTypes.update}
      />
      {showConfirmationDialog && (
        <DialogFormation
          openDialog={showConfirmationDialog}
          handleClose={handleClose}
          title={
            isActionHighlight
              ? translate("myplan.myCompletedTask.popup.heading.highlightToggle")
              : source && translate("myPlan.sectionHeader.completed.heading", { plan: source.source.toString() })
          }
          actionConfig={
            <div className="modal-config-wrapper">
              <Button label="Cancel" variant="secondary" onClick={handleClose} />
              <Button variant="primary" label="Proceed" onClick={handleProceed} />
            </div>
          }
        >
          <Typography variant="body1" color={tokens.Text.General.PrimaryHeadline} sx={{ textAlign: "center" }}>
            {isActionHighlight
              ? translate("myPlan.myCompletedTask.popup.desc", {
                  totalAction: cardsToComplete?.assignedToMe?.length.toString()
                })
              : source && (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: translate("myPlan.myCompleted.popup.desc", {
                        totalAction: Math.abs(
                          cardsToComplete?.notAssignedToMe?.length + cardsToComplete?.assignedToMe?.length
                        ).toString(),
                        plan: source.source,
                        prep: source.source === "plan" ? "on" : "in"
                      })
                    }}
                  />
                )}
          </Typography>
        </DialogFormation>
      )}
    </>
  );
}

export default MarkCompleteButton;
